import { z } from 'zod'

export const updateUserLocationSchema = z.object({
  city: z.string().min(1, 'City is required').max(100, 'City must be 100 characters or less'),
  latitude: z.number().min(-90).max(90),
  longitude: z.number().min(-180).max(180),
})

export type UpdateUserLocationInput = z.infer<typeof updateUserLocationSchema>
